(function () {
    function initHomepageShapeSlider() {
        if (typeof Swiper !== 'function') return;

        const mainEl = document.querySelector('.product-main-homepage-slider');
        const thumbEl = document.querySelector('.product-shape-homepage-slider');
        if (!mainEl || !thumbEl) return;

        const prefersHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

        mainEl.querySelectorAll('[data-hide-mobile]').forEach((slide) => slide.remove());
        thumbEl.querySelectorAll('[data-hide-mobile]').forEach((slide) => slide.remove());

        const reindexSlides = (container) => {
            container.querySelectorAll('.swiper-wrapper > .swiper-slide').forEach((slide, index) => {
                slide.dataset.shapeIndex = String(index);
                slide.querySelector('a.shape-slide')?.setAttribute('data-shape-index', String(index));
            });
        };

        reindexSlides(mainEl);
        reindexSlides(thumbEl);

        const slideCount = mainEl.querySelectorAll('.swiper-wrapper > .swiper-slide').length;
        if (!slideCount) return;

        const getShapeIndex = (slide) => {
            if (!slide) return -1;
            const index = parseInt(slide.dataset.shapeIndex, 10);
            return Number.isNaN(index) ? -1 : index;
        };

        const thumbSwiper = new Swiper(thumbEl, {
            loop: false,
            slidesPerView: 3.3,
            spaceBetween: 10,
            grabCursor: true,
            watchSlidesProgress: true,
            slideToClickedSlide: false,
            noSwipingSelector: 'a.shape-slide',
            observer: true,
            observeParents: true,
            breakpoints: {
                768: {
                    slidesPerView: 5.3,
                    spaceBetween: 15
                },
                992: {
                    slidesPerView: 7.3,
                    spaceBetween: 15
                },
                1200: {
                    slidesPerView: Math.min(10, slideCount),
                    spaceBetween: 23,
                    allowTouchMove: false
                }
            }
        });

        const mainSwiper = new Swiper(mainEl, {
            loop: slideCount > 1,
            loopedSlides: slideCount,
            slidesPerView: 1,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            navigation: {
                nextEl: '.button-next-homepage-slider',
                prevEl: '.button-prev-homepage-slider'
            }
        });

        const setActiveShape = (index) => {
            thumbEl.querySelectorAll('.swiper-slide[data-shape-index]').forEach((slide) => {
                const slideIndex = getShapeIndex(slide);
                const isActive = slideIndex === index;
                slide.classList.toggle('is-active-shape', isActive);
                slide.querySelector('.shape-slide')?.classList.toggle('is-active-shape', isActive);
            });
        };

        const syncThumbPosition = (index) => {
            if (index < 0 || index >= slideCount) return;
            thumbSwiper.slideTo(index, 0);
        };

        const goToShape = (index, { syncMain = true } = {}) => {
            if (index < 0 || index >= slideCount) return;

            setActiveShape(index);
            syncThumbPosition(index);

            if (!syncMain || mainSwiper.realIndex === index) return;

            if (mainSwiper.params.loop) {
                mainSwiper.slideToLoop(index);
            } else {
                mainSwiper.slideTo(index);
            }
        };

        const syncFromMain = () => {
            goToShape(mainSwiper.realIndex, { syncMain: false });
        };

        mainSwiper.on('slideChange', syncFromMain);
        syncFromMain();

        thumbEl.addEventListener(
            'click',
            (event) => {
                const link = event.target.closest('a.shape-slide');
                if (!link || !thumbEl.contains(link)) return;

                const slide = link.closest('.swiper-slide[data-shape-index]');
                const index = getShapeIndex(slide);
                const href = link.getAttribute('href');

                if (index < 0) return;

                setActiveShape(index);

                if (mainSwiper.realIndex !== index) {
                    if (mainSwiper.params.loop) {
                        mainSwiper.slideToLoop(index);
                    } else {
                        mainSwiper.slideTo(index);
                    }
                }

                if (!prefersHover && href) {
                    event.preventDefault();
                    window.location.assign(link.href);
                }
            },
            true
        );

        if (prefersHover) {
            thumbEl.addEventListener(
                'pointerover',
                (event) => {
                    const slide = event.target.closest('.swiper-slide[data-shape-index]');
                    if (!slide || !thumbEl.contains(slide)) return;

                    const index = getShapeIndex(slide);
                    if (index < 0) return;

                    goToShape(index);
                },
                true
            );
        }
    }

    if (typeof Swiper === 'function') {
        initHomepageShapeSlider();
        return;
    }

    const waitForSwiper = window.setInterval(() => {
        if (typeof Swiper !== 'function') return;
        window.clearInterval(waitForSwiper);
        initHomepageShapeSlider();
    }, 50);
})();
